import _ from 'underscore';

import Abstract from '../../framework/Abstract';
import Slider from '../../framework/Slider';

import './B17-news-and-events-carousel.scss';

class B17NewsAndEventsCarousel extends Abstract {
	init() {
		const figures = this.root.querySelectorAll('.B17-news-and-events-carousel__image');
		this.previousBrowserWidth = window.innerWidth;
		this.createSwiper();
		if (figures.length) this.setBackgroundImages(figures);
		// Due to different sized slides, the slider update method, doesn't calculate correctly.
		// To circumvent this, the slider is being destroyed on horizontal width change, and created again from
		// scratch with the new width. This has been debounced as well, to limit the calls.
		// (Only on horizontal change, because the url bar hides and shows when interacting with the website)
		window.addEventListener('resize', _.debounce(this.onResize, 400));
	}

	setBackgroundImages = (figures) => {
		Array.from(figures).forEach((figure) => {
			const image = figure.getElementsByTagName('img')[0];
			if (image) {
				const source = image.getAttribute('src');
				figure.style.backgroundImage = `url('${source}')`;
			}
		});
	}

	onResize = () => {
		this.browserWidth = window.innerWidth;

		if (this.browserWidth !== this.previousBrowserWidth) {
			_.each(this.slider.slides, (slide) => {
				slide.classList.remove('has-transition');
			});

			this.slider.destroy();
			this.createSwiper();

			this.previousBrowserWidth = this.browserWidth;
		}
	}

	createSwiper() {
		const sliderEl = this.root.querySelector('.swiper-container');
		const nextButton = this.root.querySelector('.swiper-nav-next');
		const prevButton = this.root.querySelector('.swiper-nav-prev');

		this.slider = new Slider(sliderEl, {
			init: false, // Workaround for mobile version instantiating the position wrongly.
			slidesPerView: 1, // Explicitly set to 1 for IE11 fix
			speed: 500,
			simulateTouch: false,
			preventInteractionOnTransition: true,
			hideOnClick: true,
			allowTouchMove: false, // Disabled touch because it over-complicates calculating slide change
			navigation: {
				nextEl: nextButton,
				prevEl: prevButton,
			},
			on: {
				init() {
					this.calculatedIndex = 0;
					_.each(this.slides, (slide) => {
						slide.classList.add('has-transition');
					});
				},
				slideChange() {
					const nonActiveSlide = this.wrapperEl.querySelector('.swiper-slide:not(.swiper-slide-active):not(.ghost-slide)');
					const nonActiveWidth = nonActiveSlide.getBoundingClientRect().width;
					this.calculatedTransitionDistance = nonActiveWidth;
				},
				slideNextTransitionStart() {
					const translate = this.getTranslate() - this.calculatedTransitionDistance;
					this.calculatedIndex = this.calculatedIndex + 1;
					this.slideTo(this.calculatedIndex);
					this.wrapperEl.style.transform = `translateX(${translate}px)`;
				},
				slidePrevTransitionStart() {
					const translate = this.getTranslate() + this.calculatedTransitionDistance;
					this.calculatedIndex = this.calculatedIndex - 1;
					this.slideTo(this.calculatedIndex);
					this.wrapperEl.style.transform = `translateX(${translate}px)`;
				},
			},
		});

		this.slider.on('slideChangeTransitionStart', () => {
			const nextSlide = this.root.querySelector('.swiper-slide-next');

			if (nextSlide.classList.contains('ghost-slide')) {
				nextButton.classList.add('swiper-button-disabled');
				this.slider.allowSlideNext = false;
			} else {
				nextButton.classList.remove('swiper-button-disabled');
				this.slider.allowSlideNext = true;
			}
		});

		// Workaround for mobile version instantiating the position wrongly.
		// (Could be due to our javascript module injection on runtime?)
		setTimeout(() => {
			this.slider.init();
		}, 0);
	}
}

export default B17NewsAndEventsCarousel;
